module.exports = __webpack_public_path__ + "static/bosslogo.692cddea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bosslogo.png
// module id = 1149
// module chunks = 133196208597199 219286714057974 236131095047554